import { parsePhoneNumber } from 'libphonenumber-js'

import { Address } from '@/types/form'

export function capitalize(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export function addressString(address: Omit<Address, 'latitude' | 'longitude'>): string {
    const fields = [address.address, address.zipcode + ' ' + address.city, address.country]

    return fields.filter((field) => !!field).join(', ')
}

export interface SplitAddress {
    address: string
    zipcode: string | null
    city: string | null
    country: string | null
}

/**
 * Attempts to split address. If it's unable to, the whole string will be returned in the `address` field
 *
 * @returns {SplitAddress}
 */
export function splitAddressString(fullAddress: string): SplitAddress {
    let address: string = fullAddress
    let zipcode: string | null = null
    let city: string | null = null
    let country: string | null = null

    const match = fullAddress.match(/\s(\d{4,})\s[^\s]+/)
    if (match) {
        zipcode = match[1]
        const split = fullAddress.split(zipcode)
        address = split[0].trim().replace(',', '')

        const cityCountryParts = split[1]
            .split(' ')
            .map((part) => part.trim().replace(',', ''))
            .filter(Boolean)

        if (cityCountryParts.length > 1) {
            country = cityCountryParts.pop() || null
        }
        city = cityCountryParts.length > 0 ? cityCountryParts.join(' ') : null
    }

    return {
        address,
        zipcode,
        city,
        country,
    }
}

export function phoneNumberString(phoneNumber: string): string {
    try {
        return parsePhoneNumber(phoneNumber).formatInternational()
    } catch (e) {
        return phoneNumber
    }
}
